<template>
  <div class="FormArticleImage">
    <div class="imageWrap">
      <template v-if="fileId">
        <Pic :src="url" />
        <Btn class="sm danger light" @click="$up('fileId', null)">
          {{ $t('remove') }}
        </Btn>
      </template>
      <ImageDrop
        v-else
        :id="imageDropId"
        :type="type"
        @update:file="$up('fileId', $event.id)" />
      <FormImageSelect
        :article="article"
        :fileId="fileId"
        :section="section"
        :type="type"
        @update:fileId="$up('fileId', $event)"
        @update:section="$up('section', $event)" />
    </div>
    <div v-if="section" class="alternativeText">
      <Field
        :placeholder="$t('alt')"
        :value="section.imageAlt"
        @update:value="$up('section.imageAlt', $event)">
        <!--
        <FieldBtn
          v-if="$listeners.generateAlternativeText"
          class="sm light"
          @click="$emit('generateAlternativeText', type)">
          {{ $t('generate') }}
        </FieldBtn>
        -->
      </Field>
    </div>
  </div>
</template>

<script>
import FormImageSelect from '@forms/FormImageSelect'
import ImageDrop from '@components/fields/ImageDrop'
import { getters } from '@utils'

export default {
  components: {
    ImageDrop,
    FormImageSelect,
  },
  props: {
    article: Object,
    fileId: Number,
    imageDropId: String,
    section: Object,
    type: String,
  },
  computed: {
    file() {
      if (!this.fileId) return

      return this.queryOne('file', this.fileId)
    },
    url() {
      return this.getFileUrl(this.file)
    },
    ...getters('getFileUrl'),
  },
}
</script>

<style lang="scss">
.FormArticleImage {
  position: relative;

  > .imageWrap {
    position: relative;

    > .Pic > img {
      border-radius: $radius;
      width: 100%;
    }
  }

  .loaderWrap {
    align-items: center;
    background: rgba($white, 0.6);
    display: flex;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    .Loader {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  .alternativeText {
    display: flex;
    flex-grow: 1;
    margin-top: 1rem;

    .Field-cont {
      margin: 0;
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "alt": "Alternative text",
    "remove": "Remove",
    "generate": "Generate"
  }
}
</i18n>
